import React, { Component } from "react";
import { Image} from "react-bootstrap";
import CopyUrlIcon from "../../assets/images/CopyUrlIcon.svg";

class CopyButton extends Component {
  constructor(props) {
    super(props);
    this.state = {
      copied: false,
    };
  }

  handleCopy = async () => {
    const { textToCopy } = this.props;

    if (textToCopy) {
      try {
        await navigator.clipboard.writeText(textToCopy);
        this.setState({ copied: true });

        setTimeout(() => {
          this.setState({ copied: false });
        }, 2000);
      } catch (error) {
        console.error("Copy failed", error);
      }
    }
  };

  render() {
    return (
      <button className="copy-btn bg-white border-0" onClick={this.handleCopy}>
        <Image src={CopyUrlIcon} alt="Copy Icon" />
        {this.state.copied && (
          <span className="text-green-500 ml-2">Copied!</span>
        )}
      </button>
    );
  }
}

export default CopyButton;
